import {
  SET_SEARCH,
} from './types';

export default {
  setSearchField({ commit }, search) {
    commit(SET_SEARCH, search);
  }
};
